import { createURLSearchParams } from '../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../common/customAxios';

export interface IGetCropDailyGraphParams {
  searchParam: {
    wholesaleMarketCode: string;
    displayDataType: 'dailyAveragePrice' | 'dailyUnitTotalQuantity';
    largeCategoryCode: string;
    middleCategoryCode: string;
    smallCategoryCode: string;
  };
}

export interface IGetCropDailyGraphResponse {
  label: string[];
  lastYearData: (number | null)[];
  thisYearData: (number | null)[];
}

export const getCropDailyGraph = ({ searchParam }: IGetCropDailyGraphParams): Promise<IGetCropDailyGraphResponse> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/crops/daily-graph?${URLSearchParams}`);
};
